// The calorie floors and manual-tweak ceiling, in ONE place.
//
// These were copied as literals across onboarding, TDEE maths, recalibration,
// the goals API and the assistant prompt — consistent by luck, not by
// construction. Every consumer now imports from here, so a future change
// moves all floors together or none at all. The floors themselves are the
// conventional safety minimums; no computed target may ever go below them.
export const ABSOLUTE_MIN_KCAL = 1200;
export const ABSOLUTE_MIN_KCAL_MALE = 1500;

/** Ceiling for manually-tweaked daily budgets (onboarding + goals editor). */
export const MAX_MANUAL_KCAL = 6000;
